module.exports = __webpack_public_path__ + "media/fonts/OpenSans-Regular-b8cc747a58ffa52b7ff9efa81dee2eb9.ttf";